"use strict";
/**
 * Content Type Constants
 * Mapping between frontend content types and WordPress post types
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getContentType = exports.getPostType = exports.CONTENT_TYPES = void 0;
exports.isAppContentTypeKey = isAppContentTypeKey;
exports.resolveListFetchContentKeyFromWpField = resolveListFetchContentKeyFromWpField;
exports.resolveWpContentTypeField = resolveWpContentTypeField;
exports.CONTENT_TYPES = {
    articles: 'posts',
    podcasts: 'podcast',
    challenges: 'challenge',
    jobs: 'job',
    plugins: 'figplg',
    templates: 'figtemp',
    projects: 'project',
    community: 'community',
    quotes: 'quote',
    sessions: 'session',
    speakers: 'speaker',
    certificates: 'certificate',
    workSamples: 'work_sample',
    favorites: 'favorites',
    shortAds: 'short_ad',
    designReviews: 'designreview',
};
/** True when `k` is a key of {@link CONTENT_TYPES} (WordPress list fetch). */
function isAppContentTypeKey(k) {
    return Object.prototype.hasOwnProperty.call(exports.CONTENT_TYPES, k);
}
/**
 * Get WordPress post type from frontend content type
 */
const getPostType = (contentType) => {
    return exports.CONTENT_TYPES[contentType] || contentType;
};
exports.getPostType = getPostType;
/**
 * Get frontend content type from WordPress post type
 */
const getContentType = (postType) => {
    const entry = Object.entries(exports.CONTENT_TYPES).find(([, wpType]) => wpType === postType);
    return entry ? entry[0] : null;
};
exports.getContentType = getContentType;
/**
 * Maps a `wp_content_type` value (or section id) to the fetch key used by the list fetch layer.
 *
 * Resolution order:
 *  1. `shortads` / `short_ad` → `'shortads'` (custom API endpoint, not a standard CPT).
 *  2. Known {@link ContentType} key (e.g. `articles`) → returned as-is.
 *  3. Known WP CPT slug (e.g. `post`, `podcast`) → mapped to the app ContentType key.
 *  4. Case-insensitive ContentType key match → normalised key.
 *  5. Unknown → `null` (caller decides whether to pass through or skip).
 */
function resolveListFetchContentKeyFromWpField(raw) {
    const t = raw.trim();
    if (!t)
        return null;
    if (t === 'shortads' || t.toLowerCase() === 'shortad' || t === 'short_ad') {
        return 'shortads';
    }
    if (isAppContentTypeKey(t))
        return t;
    const fromSlug = (0, exports.getContentType)(t);
    if (fromSlug)
        return fromSlug;
    const lower = t.toLowerCase();
    for (const key of Object.keys(exports.CONTENT_TYPES)) {
        if (key.toLowerCase() === lower)
            return key;
    }
    return null;
}
/**
 * WordPress built-in post type slugs → their REST API base.
 */
const WP_BUILTIN_REST_BASES = {
    post: 'posts',
    page: 'pages',
    attachment: 'media',
};
/**
 * Like {@link resolveListFetchContentKeyFromWpField} but used when the value was explicitly
 * set by the WP admin as `wp_content_type`. Unknown non-empty strings are returned as-is
 * so any registered CPT slug works without app code changes.
 */
function resolveWpContentTypeField(raw) {
    const t = raw.trim();
    if (!t)
        return null;
    const known = resolveListFetchContentKeyFromWpField(t);
    if (known !== null)
        return known;
    return WP_BUILTIN_REST_BASES[t] ?? t;
}
//# sourceMappingURL=ContentTypes.js.map